import { APIClient } from "../api_helper";

import * as url from "./custom_url_helper";
const api = new APIClient();


//USER
export const getAllUsers = (data) => api.get(url.GET_ALL_USERS,data);
export const userSignup = (userData) => api.create(url.USER_SIGNUP, userData);
export const userCheckout = (userData) => api.create(url.USER_CHECKOUT, userData);
export const getPaymentPlans = (postData) => api.get(url.GET_PAYMENT_PLANS,postData);

export const getPaymentPlanInfo = (planCostMappingId) => api.create(url.GET_PAYMENT_PLAN_INFO,planCostMappingId);


//Auth
export const userLoginURL = (userData) => api.create(url.USER_LOGIN, userData);

//Categories
export const getAllCategories = () => api.get(url.GET_ALL_CATEGORIES);


//Contest
export const saveUserContest = (data) => api.create(url.SAVE_USER_CONTEST, data);
export const getAllContest = (contestData) => api.get(url.GET_ALL_CONTEST,contestData);
export const getContestDetail = (data) => api.create(url.GET_CONTEST_DETAIL, data);
export const createContest = (data) => api.create(url.CREATE_CONTEST, data);
export const createParticipateContest = (data) => api.create(url.CREATE_PARTICIPATE, data);
export const handleStartDesign = (data) => api.create(url.HANDLE_START_DESIGN, data);
export const saveContestResult = (data) => api.create(url.SAVE_CONTEST_RESULT, data);

//comments
export const getContestCommnets = (data) => api.create(url.GET_CONTEST_COMMENTS, data);
export const saveContestCommnets = (data) => api.create(url.SAVE_CONTEST_COMMENTS, data);

export const getContestResult = (contestData) => api.get(url.GET_CONTEST_RESULT,contestData);
export const saveContestStatus = (data) => api.create(url.SAVE_CONTEST_STATUS, data);
export const resultSendToClient = (data) => api.create(url.RESULT_SEND_TO_CLIENT, data);

//User
export const getUserProfile = (userId) => api.create(url.GET_USER_PROFILE,userId);

//user requests
export const getUserRequests = (userId) => api.get(url.GET_USER_REQUESTS,userId);
export const acceptRejectUserRequest = (data) => api.create(url.ACCEPT_REJECT_USER_REQUEST,data);
export const getMyParticipatedContests = (data) => api.get(url.GET_MY_PARTICIPATED_CONTESTS,data);

export const getAdminStat = () => api.get(url.GET_ADMIN_STAT);
export const getUserSubscribePlanRevenue = (postData) => api.get(url.GET_USER_SUBSCRIBE_PLAN_REVENUE,postData);
export const getAdminRevenue = () => api.get(url.GET_ADMIN_REVENUE);
export const getEventEarning = (data) => api.get(url.GET_EVENT_EARNING,data);
export const getUserRewardsApi = (data) => api.get(url.GET_USER_REWARDS,data);


export const getRequestDetail = (data) => api.create(url.GET_REQUEST_DETAIL, data);

export const getNotifications = (data) => api.get(url.GET_NOTIFICATIONS,data);

//GET_ALL_STATUSES
export const getAllStatuses = () => api.get(url.GET_ALL_STATUSES);

//Rewards
export const getArtistWinRewards = (data) => api.get(url.GET_ARTIST_WINS_REWARDS,data);
export const addRewards = (data) => api.create(url.ADD_REWARDS, data);
export const addWinnerRewards = (data) => api.create(url.ADD_WINNER_REWARDS, data);
export const getRewardDetails = (data) => api.get(url.GET_REWARD_DETAILS,data);


//Events
export const getAllEvents = (data) => api.get(url.GET_ALL_EVENTS,data);
export const getEventById = (data) => api.get(url.GET_EVENT_BY_ID,data);
export const getInHouseArtists = () => api.get(url.GET_IN_HOUSE_ARTISTS);
export const addEvent = (data) => api.create(url.ADD_EVENTS, data);
export const deleteEvent = (data) => api.get(url.DELETE_EVENT, data);